export const LANGUAGES = [
  { code: "en", label: "EN" },
  { code: "tr", label: "TR" },
  { code: "fr", label: "FR" },
];

export const translations = {
  en: {
    nav: {
      manifesto: "Manifesto",
      services: "Services",
      corridors: "Trade Routes",
      contact: "Contact",
      cta: "Initiate Mandate",
    },
    hero: {
      eyebrow: "Paris · Global Trade Intermediation",
      lines: ["Global markets,", "connected with", "decisive precision."],
      sub: "Hindu Kush is a Paris-based consultancy and trade intermediary bridging Asia, Europe and the Middle East — commodity brokerage, strategic market entry and quiet trade diplomacy.",
      ctaPrimary: "Request Trade Briefing",
      ctaSecondary: "Explore the Model",
      metrics: [
        { value: "€2.4B+", label: "Intermediated Trade Volume" },
        { value: "34", label: "Active Trade Corridors" },
        { value: "3", label: "Global Hubs" },
      ],
      scroll: "Scroll",
      logoCaption: "The Banyan — rooted authority, boundless reach",
    },
    marquee: [
      "Cross-Border Supply Chain",
      "Commodity Brokering",
      "Strategic Market Entry",
      "Risk Mitigation",
      "Trade Diplomacy",
      "Market Intelligence",
    ],
    manifesto: {
      eyebrow: "The Banyan Philosophy",
      title: "Rooted like the banyan. Reaching like the trade winds.",
      chapters: [
        {
          num: "01",
          title: "Rooted Authority",
          text: "Decades of intelligence across Eurasian trade corridors. We know each market's language, rhythm and doors.",
        },
        {
          num: "02",
          title: "Discretion & Intermediation",
          text: "Neutral ground for high-value contracts. Confidentiality is the currency of trust.",
        },
        {
          num: "03",
          title: "Kinetic Execution",
          text: "Rapid capital and commodity deployment across borders. When the window opens, we are already there.",
        },
        {
          num: "04",
          title: "AI-Enhanced Analytics",
          text: "Legacy diplomacy fused with real-time AI market signals — judgment amplified by machines, never replaced.",
        },
      ],
    },
    services: {
      eyebrow: "Intermediation Matrix",
      title: "Five disciplines. One table.",
      sub: "Every mandate is structured end-to-end — from first signal to signed contract.",
      items: [
        {
          title: "Commodity & Energy Intermediation",
          text: "Structured brokerage bringing buyers and sellers of oil, metals and agri-commodities to the same table.",
        },
        {
          title: "Market Entry & Cross-Border Advisory",
          text: "Entry strategy, local partner selection and regulatory mapping for new territories.",
        },
        {
          title: "Trade Finance & Risk Mitigation",
          text: "Transactional security through letters of credit, guarantees and insurance structures.",
        },
        {
          title: "Government Relations & Trade Diplomacy",
          text: "The right channel, at the right moment, with public institutions.",
        },
        {
          title: "AI-Driven Supply Chain Intelligence",
          text: "Route, price and risk analysis powered by real-time signals.",
        },
      ],
    },
    corridors: {
      eyebrow: "Trade Routes",
      title: "Living lines from Paris to the East",
      sub: "A curated network of active corridors. Filter by trade category.",
      filters: [
        { id: "all", label: "All" },
        { id: "commodities", label: "Commodities" },
        { id: "technology", label: "Technology" },
        { id: "agriculture", label: "Agriculture" },
        { id: "industrial", label: "Industrial Machinery" },
      ],
      nodeLabels: {
        paris: "Paris — HQ",
        istanbul: "Istanbul",
        tashkent: "Tashkent",
        dubai: "Dubai",
        singapore: "Singapore",
      },
      hint: "Hover a node · filter a corridor",
    },
    contact: {
      eyebrow: "Contact",
      title: "A table awaits you in Paris",
      sub: "Mandates begin with a conversation. Write to us — we reply within one business day.",
      addressLabel: "Address",
      phoneLabel: "Phone",
      emailLabel: "Email",
      formTitle: "Initiate a mandate",
      name: "Full name",
      email: "Email",
      company: "Company",
      subject: "Mandate type",
      mandates: [
        "Commodity Intermediation",
        "Market Entry",
        "Trade Finance",
        "Government Relations",
        "Other",
      ],
      message: "Your message",
      submit: "Send inquiry",
      sending: "Sending…",
      success: "Your inquiry has been received. We will respond shortly.",
      error: "Something went wrong. Please try again.",
    },
    chat: {
      title: "Trade Concierge",
      subtitle: "AI · answers in EN / TR / FR",
      greeting:
        "Welcome to Hindu Kush. I can answer questions on trade intermediation, market entry, or our Paris office. How may I assist?",
      placeholder: "Write your question…",
      chips: [
        "How does Hindu Kush handle commodity brokerage?",
        "Paris office contact details",
        "Market entry advisory process",
      ],
      typing: "Composing…",
    },
    footer: {
      tagline: "Global Market Consulting & Trade Intermediation",
      pledge:
        "Every mandate is held under strict confidentiality. No names, no volumes, no exceptions.",
      explore: "Explore",
      contactTitle: "Direct line",
      rights: "© 2026 Hindu Kush. All rights reserved.",
    },
  },
  tr: {
    nav: {
      manifesto: "Manifesto",
      services: "Hizmetler",
      corridors: "Ticaret Rotaları",
      contact: "İletişim",
      cta: "Görüşme Talep Et",
    },
    hero: {
      eyebrow: "Paris · Küresel Ticaret Aracılığı",
      lines: ["Küresel pazarlar,", "kararlı bir ustalıkla", "birbirine bağlanır."],
      sub: "Hindu Kush; Asya, Avrupa ve Orta Doğu arasında köprü kuran, Paris merkezli bir danışmanlık ve ticari aracı kurumdur — emtia aracılığı, stratejik pazar girişi ve sessiz ticaret diplomasisi.",
      ctaPrimary: "Ticaret Brifingi Talep Et",
      ctaSecondary: "Modeli Keşfet",
      metrics: [
        { value: "€2.4B+", label: "Aracılık Edilen Ticaret Hacmi" },
        { value: "34", label: "Aktif Ticaret Koridoru" },
        { value: "3", label: "Küresel Merkez" },
      ],
      scroll: "Kaydır",
      logoCaption: "Banyan — köklü otorite, sınırsız erişim",
    },
    marquee: [
      "Sınır Ötesi Tedarik Zinciri",
      "Emtia Aracılığı",
      "Stratejik Pazar Girişi",
      "Risk Azaltma",
      "Ticaret Diplomasisi",
      "Pazar İstihbaratı",
    ],
    manifesto: {
      eyebrow: "Banyan Felsefesi",
      title: "Banyan gibi köklü. Ticaret rüzgârları gibi geniş.",
      chapters: [
        {
          num: "01",
          title: "Köklü Otorite",
          text: "Avrasya ticaret koridorlarında onlarca yıllık istihbarat derinliği. Her pazarın dilini, ritmini ve kapılarını biliriz.",
        },
        {
          num: "02",
          title: "İhtiyat ve Aracılık",
          text: "Yüksek değerli sözleşmeler için tarafsız zemin. Gizlilik, güvenin para birimidir.",
        },
        {
          num: "03",
          title: "Kinetik İcra",
          text: "Sınırlar ötesinde hızlı sermaye ve emtia hareketi. Fırsat penceresi açıldığında biz çoktan oradayız.",
        },
        {
          num: "04",
          title: "AI Destekli Analitik",
          text: "Köklü diplomasi, gerçek zamanlı yapay zekâ pazar sinyalleriyle birleşir — muhakeme makineyle güçlenir, asla yerini kaybetmez.",
        },
      ],
    },
    services: {
      eyebrow: "Aracılık Matrisi",
      title: "Beş disiplin. Tek masa.",
      sub: "Her mandat uçtan uca yapılandırılır — ilk sinyalden imzalı sözleşmeye.",
      items: [
        {
          title: "Emtia ve Enerji Aracılığı",
          text: "Petrol, metaller ve tarım ürünlerinde alıcı ile satıcıyı aynı masada buluşturan yapılandırılmış aracılık.",
        },
        {
          title: "Pazar Girişi ve Sınır Ötesi Danışmanlık",
          text: "Yeni pazara giriş stratejisi, yerel ortak seçimi ve regülasyon haritası.",
        },
        {
          title: "Ticaret Finansmanı ve Risk Azaltma",
          text: "Akkreditif, teminat ve sigorta yapılarıyla işlem güvenliği.",
        },
        {
          title: "Kamu İlişkileri ve Ticaret Diplomasisi",
          text: "Devlet kurumlarıyla doğru kanaldan, doğru zamanda temas.",
        },
        {
          title: "AI Destekli Tedarik Zinciri İstihbaratı",
          text: "Gerçek zamanlı sinyallerle rota, fiyat ve risk analizi.",
        },
      ],
    },
    corridors: {
      eyebrow: "Ticaret Rotaları",
      title: "Paris'ten doğuya uzanan canlı hatlar",
      sub: "Aktif koridorlardan oluşan seçkin bir ağ. Ticaret kategorisine göre filtreleyin.",
      filters: [
        { id: "all", label: "Tümü" },
        { id: "commodities", label: "Emtia" },
        { id: "technology", label: "Teknoloji" },
        { id: "agriculture", label: "Tarım" },
        { id: "industrial", label: "Endüstriyel Makine" },
      ],
      nodeLabels: {
        paris: "Paris — Merkez",
        istanbul: "İstanbul",
        tashkent: "Taşkent",
        dubai: "Dubai",
        singapore: "Singapur",
      },
      hint: "Bir düğüme dokunun · bir koridoru filtreleyin",
    },
    contact: {
      eyebrow: "İletişim",
      title: "Paris'te bir masa sizi bekliyor",
      sub: "Her mandat bir sohbetle başlar. Bize yazın — bir iş günü içinde dönüş yaparız.",
      addressLabel: "Adres",
      phoneLabel: "Telefon",
      emailLabel: "E-posta",
      formTitle: "Mandat başlatın",
      name: "Ad Soyad",
      email: "E-posta",
      company: "Şirket",
      subject: "Mandat türü",
      mandates: [
        "Emtia Aracılığı",
        "Pazar Girişi",
        "Ticaret Finansmanı",
        "Kamu İlişkileri",
        "Diğer",
      ],
      message: "Mesajınız",
      submit: "Mesajı gönder",
      sending: "Gönderiliyor…",
      success: "Mesajınız alındı. En kısa sürede dönüş yapacağız.",
      error: "Bir hata oluştu. Lütfen tekrar deneyin.",
    },
    chat: {
      title: "Ticaret Asistanı",
      subtitle: "AI · EN / TR / FR yanıtlar",
      greeting:
        "Hindu Kush'a hoş geldiniz. Ticaret aracılığı, pazar girişi veya Paris ofisimiz hakkında sorularınızı yanıtlayabilirim. Nasıl yardımcı olayım?",
      placeholder: "Sorunuzu yazın…",
      chips: [
        "Hindu Kush emtia aracılığını nasıl yürütür?",
        "Paris ofisi iletişim bilgileri",
        "Pazar girişi danışmanlık süreci",
      ],
      typing: "Yazıyor…",
    },
    footer: {
      tagline: "Küresel Pazar Danışmanlığı ve Ticaret Aracılığı",
      pledge:
        "Her mandat katı gizlilik altında yürütülür. İsim yok, hacim yok, istisna yok.",
      explore: "Keşfet",
      contactTitle: "Doğrudan hat",
      rights: "© 2026 Hindu Kush. Tüm hakları saklıdır.",
    },
  },
  fr: {
    nav: {
      manifesto: "Manifeste",
      services: "Services",
      corridors: "Routes Commerciales",
      contact: "Contact",
      cta: "Ouvrir un Mandat",
    },
    hero: {
      eyebrow: "Paris · Intermédiation Commerciale Mondiale",
      lines: ["Les marchés mondiaux,", "reliés avec une", "précision décisive."],
      sub: "Hindu Kush est un cabinet de conseil et d'intermédiation commerciale basé à Paris, reliant l'Asie, l'Europe et le Moyen-Orient — courtage de matières premières, entrée stratégique sur les marchés et diplomatie commerciale discrète.",
      ctaPrimary: "Demander un Briefing",
      ctaSecondary: "Découvrir le Modèle",
      metrics: [
        { value: "2,4 Mds €+", label: "Volume d'Échanges Intermédiés" },
        { value: "34", label: "Corridors Commerciaux Actifs" },
        { value: "3", label: "Hubs Mondiaux" },
      ],
      scroll: "Défiler",
      logoCaption: "Le Banian — autorité enracinée, portée sans limites",
    },
    marquee: [
      "Chaîne d'Approvisionnement Transfrontalière",
      "Courtage de Matières Premières",
      "Entrée Stratégique sur les Marchés",
      "Atténuation des Risques",
      "Diplomatie Commerciale",
      "Intelligence de Marché",
    ],
    manifesto: {
      eyebrow: "La Philosophie du Banian",
      title: "Enraciné comme le banian. Étendu comme les alizés.",
      chapters: [
        {
          num: "01",
          title: "Autorité Enracinée",
          text: "Des décennies d'intelligence sur les corridors eurasiens. Nous connaissons la langue, le rythme et les portes de chaque marché.",
        },
        {
          num: "02",
          title: "Discrétion & Intermédiation",
          text: "Un terrain neutre pour les contrats de haute valeur. La confidentialité est la monnaie de la confiance.",
        },
        {
          num: "03",
          title: "Exécution Cinétique",
          text: "Déploiement rapide de capitaux et de marchandises au-delà des frontières. Quand la fenêtre s'ouvre, nous y sommes déjà.",
        },
        {
          num: "04",
          title: "Analytique Augmentée par l'IA",
          text: "La diplomatie patrimoniale fusionne avec les signaux de marché en temps réel — le jugement amplifié, jamais remplacé.",
        },
      ],
    },
    services: {
      eyebrow: "Matrice d'Intermédiation",
      title: "Cinq disciplines. Une seule table.",
      sub: "Chaque mandat est structuré de bout en bout — du premier signal au contrat signé.",
      items: [
        {
          title: "Intermédiation Matières Premières & Énergie",
          text: "Courtage structuré réunissant acheteurs et vendeurs de pétrole, de métaux et de produits agricoles.",
        },
        {
          title: "Entrée sur les Marchés & Conseil Transfrontalier",
          text: "Stratégie d'entrée, sélection de partenaires locaux et cartographie réglementaire.",
        },
        {
          title: "Financement du Commerce & Atténuation des Risques",
          text: "Sécurité transactionnelle via crédits documentaires, garanties et assurances.",
        },
        {
          title: "Relations Institutionnelles & Diplomatie Commerciale",
          text: "Le bon canal, au bon moment, auprès des institutions publiques.",
        },
        {
          title: "Intelligence Logistique Pilotée par l'IA",
          text: "Analyse des routes, des prix et des risques par signaux en temps réel.",
        },
      ],
    },
    corridors: {
      eyebrow: "Routes Commerciales",
      title: "Des lignes vivantes de Paris vers l'Orient",
      sub: "Un réseau curé de corridors actifs. Filtrez par catégorie d'échanges.",
      filters: [
        { id: "all", label: "Tous" },
        { id: "commodities", label: "Matières Premières" },
        { id: "technology", label: "Technologie" },
        { id: "agriculture", label: "Agriculture" },
        { id: "industrial", label: "Machines Industrielles" },
      ],
      nodeLabels: {
        paris: "Paris — Siège",
        istanbul: "Istanbul",
        tashkent: "Tachkent",
        dubai: "Dubaï",
        singapore: "Singapour",
      },
      hint: "Survolez un nœud · filtrez un corridor",
    },
    contact: {
      eyebrow: "Contact",
      title: "Une table vous attend à Paris",
      sub: "Tout mandat commence par une conversation. Écrivez-nous — réponse sous un jour ouvré.",
      addressLabel: "Adresse",
      phoneLabel: "Téléphone",
      emailLabel: "E-mail",
      formTitle: "Ouvrir un mandat",
      name: "Nom complet",
      email: "E-mail",
      company: "Société",
      subject: "Type de mandat",
      mandates: [
        "Intermédiation Matières Premières",
        "Entrée sur les Marchés",
        "Financement du Commerce",
        "Relations Institutionnelles",
        "Autre",
      ],
      message: "Votre message",
      submit: "Envoyer la demande",
      sending: "Envoi…",
      success: "Votre demande a bien été reçue. Nous revenons vers vous rapidement.",
      error: "Une erreur est survenue. Veuillez réessayer.",
    },
    chat: {
      title: "Concierge Commercial",
      subtitle: "IA · répond en EN / TR / FR",
      greeting:
        "Bienvenue chez Hindu Kush. Je réponds à vos questions sur l'intermédiation commerciale, l'entrée sur les marchés ou notre bureau de Paris. Comment puis-je vous aider ?",
      placeholder: "Écrivez votre question…",
      chips: [
        "Comment Hindu Kush facilite le courtage de matières premières ?",
        "Coordonnées du bureau de Paris",
        "Processus de conseil en entrée de marché",
      ],
      typing: "Rédaction…",
    },
    footer: {
      tagline: "Conseil Marchés Mondiaux & Intermédiation Commerciale",
      pledge:
        "Chaque mandat est traité sous stricte confidentialité. Aucun nom, aucun volume, aucune exception.",
      explore: "Explorer",
      contactTitle: "Ligne directe",
      rights: "© 2026 Hindu Kush. Tous droits réservés.",
    },
  },
};
